var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"four-oh-four"},[_c('h1',[_vm._v("404 - Page not found.")]),_c('p',[_vm._v("Click "),_c('a',{attrs:{"href":"https://fcbstudios.com"}},[_vm._v("here")]),_vm._v(" to return to the home page.")])])
}]

export { render, staticRenderFns }